import React from 'react';
import { useTranslation } from 'react-i18next';
import { CompanyDto } from '@jaam/commons/dtos';
import {
  ChevronDown24Regular,
  Checkmark24Regular,
} from '@fluentui/react-icons';

interface Iprops {
  company: CompanyDto;
  checkIcon?: string;
  active?: boolean;
  companyListStatus?: boolean;
  showUserCompanies?: () => void;
  handleClick: (company: CompanyDto) => void;
}
export const CompanyItem = ({
  company,
  checkIcon,
  active,
  companyListStatus,
  showUserCompanies,
  handleClick,
}: Iprops): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <div className="p-0 ">
      <button
        type="button"
        className="w-full p-0 transition-all duration-200 rounded-borderRadius10 hover:bg-blue-95 group "
        onClick={active ? showUserCompanies : () => handleClick(company)}
        data-testid="company-dropdownlist"
      >
        <div className="flex  h-[64px] w-full py-2.5 px-4 items-center  ">
          {company.logo ? (
            <div className="flex flex-col justify-center w-12 h-12  ml-0 mr-4 bg-neutral-95 rounded-xl hover:border-none">
              <div className="">
                <img
                  className="max-h-12 max-w-12 "
                  src={company.logo}
                  alt={company.name}
                />
              </div>
            </div>
          ) : (
            <div className="w-12 h-12 my-2 mr-2 min-w-12 bg-neutral-95 rounded-xl group-hover:bg-neutral-80 " />
          )}
          <div className="flex justify-between w-full ">
            <div className="flex flex-col justify-between">
              {companyListStatus && active && (
                <div className="text-xs text-left text-neutral-20  ">
                  {t('company.label')}
                </div>
              )}
              <div
                className="font-semibold text-center capitalize"
                data-testId="companyValue-button"
              >
                {company.name}
              </div>
            </div>
            <div className="flex items-center gap-2 text-neutral-40">
              {active &&
                (companyListStatus ? (
                  <ChevronDown24Regular />
                ) : (
                  <Checkmark24Regular color="#2277db" />
                ))}
            </div>
          </div>
        </div>
      </button>
    </div>
  );
};

CompanyItem.defaultProps = {
  checkIcon: '',
  companyListStatus: false,
  active: false,
  showUserCompanies: () => ({}),
};
export default CompanyItem;
